var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:{'vuw-disabled': _vm.item.Disabled}},[_c('input',{staticClass:"vuw-checkbox",attrs:{"type":"checkbox","id":_vm.item.FilterCodeName},domProps:{"value":_vm.item.FilterCodeName,"checked":_vm.checked(_vm.item.FilterCodeName)},on:{"change":function($event){return _vm.$emit('change',
    {
      codename: _vm.item.FilterCodeName,
      checked: $event.target.checked,
      label: _vm.item.DisplayName
    })}}}),_c('label',{attrs:{"for":_vm.item.FilterCodeName}},[_vm._v(_vm._s(_vm.item.DisplayName))])])}
var staticRenderFns = []

export { render, staticRenderFns }